import { post, get } from '../request'
import { API_SUCCESS, API_FAILURE } from '~/helper/constant/api_status'
import ApiResponse from '~/model/response'

export const viewDrive = (token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('drive', token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const addDrive = (data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('drive/add', token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const editDrive = (id, data, token) => {
    return new Promise(function (resolve, reject) {
        try {
            post('drive/update/' + id, token, data).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}

export const getDriveItems = (id, token) => {
    return new Promise(function (resolve, reject) {
        try {
            get('drive/edit/' + id, token).then((response) => {
                resolve(response)
            })
        } catch ($e) {
            resolve(null)
        }
    })
}
